module.exports = __webpack_public_path__ + "img/jogadoresanonimosbr.f0fd62f2.png";